import { Grid } from '@mui/material'
import React from 'react'
import ProcurarVisitanteDentro from './ProcurarVisitanteDentro/ProcurarVisitanteDentro'
import ListaVisitantesDentro from './ListaVisitantesDentro/ListaVisitantesDentro'
import Metricas from './Metricas/Metricas'

const SaidasTab = () => {
    return (
        <Grid sx={{ height: '100%', width: '100%' }}>
            <ProcurarVisitanteDentro></ProcurarVisitanteDentro>
            <Grid sx={{ display: 'flex', width: '100%', height: '100%' }}>
                <ListaVisitantesDentro></ListaVisitantesDentro>
                <Grid sx={{ width: '20%', height: '90%' }}>
                    <Metricas></Metricas>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default SaidasTab
